<template>
  <wrap>
    <div
      class="card-preview-video"
      @click="handleClick"
    >
      <image-clip :src="previewUrl" />
      <div class="preview-video-btn">
        <i class="btn-play"></i>
      </div>
    </div>
    <card-title @click="handleClick">{{ title }}</card-title>
    <author :author-info="authorInfo"/>
  </wrap>
</template>

<script>
import Wrap from '@/components/Card/parts/Wrap';
import ImageClip from '@/components/common/ImageClip';
import CardTitle from '@/components/Card/parts/CardTitle';
import Author from '@/components/Author/Author';
import CardFeed from '@/components/base/Card/CardFeed';

export default {
  name: 'CardVideo',

  mixins: [CardFeed],

  components: {
    Author,
    CardTitle,
    ImageClip,
    Wrap
  },
  methods: {
    handleClick() {
      if (this.useMobileUI) {
        this.jumpToDetail(this.feed);
      } else {
        this.$emit('click', this.feed);
      }
    }
  }
};
</script>

<style lang="less">
.card-preview-video {
  width: 100%;
  height: 162px;
  cursor: pointer;
  position: relative;
  margin-bottom: @spacing-xs;
  border-bottom: 1px solid @blue-primary;
  &:hover {
    .preview-video-btn {
      opacity: 1;
    }
  }
}

.preview-video-btn {
  @btn-play-size: 48px;

  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0;
  transition: opacity .2s;
  transform: translate(-50%, -50%);

  .btn-play {
    display: block;
    width: @btn-play-size;
    height: @btn-play-size;
    background: url('~assets/icons/icon_card_play.svg') no-repeat;
  }
}
</style>
